import React, { useEffect, useState } from 'react';
import { useAuth } from '../services/auth.service';
import { default as ReactSelect } from "react-select";
import axios from 'axios';
import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';

export default function SidebarInfo(props) {
    const [name, setName] = useState(props.contact?.NombreCompleto ? props.contact?.NombreCompleto : props.contact.Celular);
    const [number, setNumber] = useState(props.contact.Celular);
    const [notas, setNotas] = useState(props.contact?.notas ? props.contact?.notas : "");
    const [etiquetas, setEtiquetas] = useState([]);
    const [selectedTags, setSelectedTags] = useState(props.contact?.etiquetas ? (props.contact?.etiquetas) : []);
    const [updating, setUpdating] = useState(false);
    const [ejecutivoAsignado, setEjecutivoAsignado] = useState(props.contact?.ejecutivoAsignado ? (props.contact?.ejecutivoAsignado) : []);
    const [sucursalChat, setSucursalChat] = useState(props.contact?.sucursalChat ? (props.contact?.sucursalChat) : []);
    const [cbp, setCBP] = useState(props.contact?.conversation ? (props.contact?.conversation) : []);
    const [templates, setTemplates] = useState([]);
    const [plantillaSeleccionada, setPlantillaSeleccionada] = useState([]);
    const { user, logout } = useAuth();
    const [ejecutivos, setEjecutivos] = useState([]);
    const [expirationTimer, setExpirationTimer] = useState([]);
    const [expirationWidth, setExpirationWidth] = useState([]);
    const [expirationType, setExpirationType] = useState([]);
    const [timer, setTimer] = useState(undefined);

    const ReactSelectElement = styled(ReactSelect)`
        .react-select__control {
            border: 1px solid #e2e8f0;
            border-radius: 0.375rem;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.25rem;
            padding: 0.5rem 1rem;
            color: #4a5568;
            background-color: #fff;
            transition: all 0.2s;
            &:hover {
                border-color: #ff0000;
            }
            &:focus {
                border-color: #cbd5e0;
                box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
                outline: 0;
            }
        }
        .react-select__value-container {
            padding: 0;
        }
        .react-select__placeholder {
            color: #a0aec0;
        }
        .react-select__single-value {
            color: #4a5568;
        }
        .react-select__indicator-separator {
            display: none;
        }
        .react-select__indicator {
            color: #a0aec0;
            &:hover {
                color: #4a5568;
            }
        }
        .react-select__menu {
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.25rem;
            color: #4a5568;
            background-color: #fff;
            border: 1px solid #e2e8f0;
            border-radius: 0.375rem;
            margin-top: 0.25rem;
            box-shadow: 0 0.5rem 1rem rgba(50, 50, 93, 0.1),

                0 0.125rem 0.25rem rgba(0, 0, 0, 0.08);
            &:hover {
                border-color: #cbd5e0;
            }
        }
        .react-select__menu-list {
            padding: 0;
        }
        .react-select__option {
            padding: 0.5rem 1rem;
            &:hover {
                background-color: #f7fafc;
            }
        }
        .react-select__option--is-selected {
            background-color: #edf2f7;
        }
        .react-select__option--is-focused {
            background-color: #edf2f7;
        }
        .react-select__multi-value {
            background-color: #e2e8f0;
            border-radius: 0.375rem;
            color: #4a5568;
            padding: 0.25rem 0.5rem;
            margin: 0.125rem;
        }
        .react-select__multi-value__label {
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.25rem;
        }
        .react-select__multi-value__remove {
            color: #a0aec0;
            &:hover {
                color: #4a5568;
            }
        }
    `;


    useEffect(() => {
        setName(props.contact?.NombreCompleto ? props.contact?.NombreCompleto : props.contact.Celular);
        setNumber(props.contact.Celular);
        setNotas(props.contact?.notas ? props.contact?.notas : "");
        setSelectedTags(props.contact?.etiquetas ? (props.contact?.etiquetas) : []);
        setEjecutivoAsignado(props.contact?.ejecutivoAsignado ? (props.contact?.ejecutivoAsignado) : []);
        setSucursalChat(props.contact?.sucursalChat ? (props.contact?.sucursalChat) : []);
        setCBP(props.contact?.conversation ? (props.contact?.conversation) : []);
        //set a timer to expiration time that updates every second the time left from max of 24 hours

        async function fetchEtiquetas() {
            try {
                let url = `${process.env.REACT_APP_BACKEND_API}/tag`;
                let config = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        "x-access-token": user.accessToken,
                    },
                };

                const response = await axios.get(url, config);
                let newEtiquetas = response.data.map((etiqueta) => {
                    return { value: etiqueta._id, label: etiqueta.name, selected: false };
                }
                );
                setEtiquetas(newEtiquetas);

            } catch (error) {
                console.log(error);
            }
        }
        fetchEtiquetas();
        async function fetchTemplates() {
            try {
                let url = `${process.env.REACT_APP_BACKEND_API}/template`;
                let config = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        "x-access-token": user.accessToken,
                    },
                };

                const response = await axios.get(url, config);
                let newTemplates = response.data.map((template) => {
                    let isImageOrVideo = template['image-video-select'] ? template['image-video-select'].value : null;
                    if (isImageOrVideo == "image") {
                        return { value: template._id, label: template.name, image: template.image, video: "" };
                    } else if (isImageOrVideo == "video") {
                        return { value: template._id, label: template.name, video: template.video, image: "" };
                    } else {
                        return { value: template._id, label: template.name, video: template.video, image: template.image };
                    }
                }
                );
                setTemplates(newTemplates);

            } catch (error) {
                console.log(error);
            }
        }
        fetchTemplates();
    }, [props.contact.Celular]);

    useEffect(() => {
        if (updating)
            updateContactInfo();
    }, [updating]);

    useEffect(() => {
        if (cbp.length > 0) {
            setExpirationTimer([]);
            setExpirationWidth([]);
            setExpirationType([]);
            if (timer)
                clearInterval(timer);
            setTimer(
                setInterval(() => {
                    expirationFunction();
                }, 10000)
            );
            const expirationFunction = () => {
                let tempExpirationTimer = [];
                let tempExpirationWidth = [];
                let tempExpirationType = [];
                let expiredTimers = 0;

                props.contact.conversation.forEach((conversation, idx) => {
                    let expirationTime = new Date(conversation.expiration_timestamp * 1000);
                    let now = new Date();
                    let timeLeft = expirationTime - now;
                    let skip = false;
                    if (timeLeft <= 0) {
                        //remove the element
                        tempExpirationTimer.splice(idx, 1);
                        tempExpirationWidth.splice(idx, 1);
                        expiredTimers++;
                        if (timer && expiredTimers == props.contact.conversation.length)
                            clearInterval(timer);
                        //skip
                        skip = true;
                    }
                    if (!skip) {
                        let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

                        tempExpirationTimer.push(hours + "h " + minutes + "m");
                        tempExpirationWidth.push(parseInt(hours / 24 * 100) + "%");
                        tempExpirationType.push(conversation.origin.type);
                    }
                });
                setExpirationTimer(tempExpirationTimer.map((expirationTimer) => expirationTimer));
                setExpirationWidth(tempExpirationWidth.map((expirationWidth) => expirationWidth));
                setExpirationType(tempExpirationType.map((expirationType) => expirationType));

                if (props.contact.conversation.length == 0) {
                    if (timer)
                        clearInterval(timer);
                }
            }
            expirationFunction();

        } else {
            setExpirationTimer([]);
            setExpirationWidth([]);
            setExpirationType([]);
            if (timer)
                clearInterval(timer);
        }
    }, [cbp]);

    useEffect(() => {
        async function fetchEjecutivos() {
            const url = `${process.env.REACT_APP_BACKEND_API}/ejecutivo`;
            const config = {
                headers: {
                    'x-access-token': user.accessToken,
                    'Content-Type': 'application/json',
                }
            }
            const response = await axios.get(url, config)
                .then((data) => {
                    let newEjecutivos = data.data.map((ejecutivo) => {
                        return { value: ejecutivo._id, label: ejecutivo.firstName + " " + ejecutivo.lastName, selected: ejecutivoAsignado.includes(ejecutivo._id) };
                    });
                    setEjecutivos(newEjecutivos);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        fetchEjecutivos();
    }, [sucursalChat]);

    function updateContactInfo() {
        setUpdating(false);
        fetch(`${process.env.REACT_APP_BACKEND_API}/contacts/${number}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                "x-access-token": user.accessToken,
            },
            body: JSON.stringify({
                wa_id: number,
                NombreCompleto: name,
                notas: notas,
                etiquetas: selectedTags,
                ejecutivoAsignado: ejecutivoAsignado,
                sucursalChat: sucursalChat,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Success:', data);
                props.onUpdateContact(number, { NombreCompleto: name, notas: notas, etiquetas: selectedTags, ejecutivoAsignado: ejecutivoAsignado, sucursalChat: sucursalChat }, props.contact.inboxtype);
            }
            );

    }

    return (
        <div className="w-2/5 border-l-2 px-5 hidden md:block" id="sidebarContainer">
            <div className="flex flex-col">
                <div className="font-semibold text-xl py-4">
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        //update the name when press ENTER
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                setUpdating(true);
                                e.target.blur();
                            }
                        }}
                    />
                </div>
                <img
                    src="/icon.png"
                    className="object-cover rounded-xl h-24"
                    alt=""
                />
                <div className="font-semibold py-4 flex flex-row content-between">
                    <div>{number}</div>
                    <div><a href={`https://wa.me/${number}`} target='_blank'><svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M17 2.75C14.6528 2.75 12.75 4.65279 12.75 7C12.75 7.68122 12.9098 8.32298 13.1931 8.89186C13.3521 9.2111 13.418 9.60224 13.3131 9.99416L13.06 10.94L14.0059 10.6869C14.3978 10.5821 14.7889 10.6479 15.1082 10.8069C15.6771 11.0903 16.3188 11.25 17 11.25C19.3472 11.25 21.25 9.34721 21.25 7C21.25 4.65279 19.3472 2.75 17 2.75ZM11.25 7C11.25 3.82436 13.8244 1.25 17 1.25C20.1757 1.25 22.75 3.82436 22.75 7C22.75 10.1756 20.1757 12.75 17 12.75C16.0816 12.75 15.2114 12.5341 14.4394 12.1496C14.4221 12.141 14.4082 12.1376 14.3998 12.1366C14.3959 12.1361 14.3936 12.1362 14.3926 12.1362L13.2806 12.4338C12.2399 12.7122 11.2878 11.7601 11.5663 10.7195L11.8638 9.60744C11.8639 9.60649 11.8639 9.60415 11.8634 9.6002C11.8624 9.5918 11.859 9.5779 11.8504 9.56061C11.4659 8.78866 11.25 7.91847 11.25 7ZM3.7177 4.09213C4.94388 2.80119 6.9721 3.04305 7.98569 4.47663L9.24668 6.26012C10.0574 7.40678 9.98893 9.00095 9.02135 10.0196L8.7765 10.2774C8.77582 10.2792 8.7751 10.2811 8.77436 10.2832C8.76142 10.3196 8.7287 10.4354 8.7609 10.6551C8.82765 11.1106 9.1793 12.0363 10.607 13.5394C12.0391 15.0472 12.9078 15.4025 13.3103 15.4679C13.484 15.4961 13.5748 15.4716 13.6038 15.4614L14.0124 15.0312C14.8862 14.1113 16.2485 13.93 17.347 14.5623L19.2575 15.662C20.8904 16.6019 21.2705 18.901 19.9655 20.2749L18.545 21.7705C18.1016 22.2373 17.497 22.6357 16.75 22.7095C14.9261 22.8895 10.701 22.655 6.27161 17.9917C2.13844 13.6403 1.35326 9.85536 1.25401 8.00613C1.20497 7.09246 1.61224 6.30877 2.14809 5.74462L2.69189 6.26114L2.1481 5.74462L3.7177 4.09213ZM6.7609 5.3426C6.24855 4.61795 5.32812 4.57471 4.80528 5.12516L3.23568 6.77765C2.90429 7.12654 2.73042 7.52644 2.75185 7.92574C2.83289 9.43555 3.48307 12.8778 7.35919 16.9587C11.4234 21.2375 15.1676 21.3584 16.6026 21.2167C16.8864 21.1887 17.1783 21.0313 17.4574 20.7375L18.8779 19.2419C19.4907 18.5968 19.3301 17.4345 18.5092 16.962L16.5987 15.8623C16.086 15.5672 15.4854 15.6584 15.1 16.0642L14.6445 16.5437L14.1008 16.0272C14.6445 16.5437 14.6439 16.5444 14.6432 16.5452L14.6417 16.5467L14.6388 16.5497L14.6324 16.5562L14.6181 16.5703C14.6078 16.5803 14.5959 16.5913 14.5825 16.6031C14.5556 16.6266 14.5223 16.6535 14.4824 16.6819C14.4022 16.7387 14.2955 16.8012 14.1606 16.8544C13.8846 16.9632 13.5201 17.0216 13.0699 16.9485C12.1923 16.806 11.0422 16.1757 9.51937 14.5724C7.99202 12.9644 7.40746 11.7647 7.27675 10.8726C7.21022 10.4185 7.26346 10.0549 7.36116 9.78033C7.40921 9.64531 7.46594 9.53764 7.51826 9.45588C7.54435 9.41512 7.56922 9.38098 7.5912 9.3532C7.60219 9.33931 7.61246 9.32701 7.62182 9.31625L7.63514 9.30127L7.64125 9.29463L7.64415 9.29152L7.64556 9.29002C7.64626 9.28929 7.64695 9.28856 8.19074 9.80507L7.64695 9.28856L7.93376 8.9866C8.3793 8.51753 8.44403 7.72315 8.02189 7.12608L6.7609 5.3426ZM17 4.25C17.4143 4.25 17.75 4.58579 17.75 5V6.25H19C19.4143 6.25 19.75 6.58579 19.75 7C19.75 7.41421 19.4143 7.75 19 7.75H17.75V9C17.75 9.41421 17.4143 9.75 17 9.75C16.5858 9.75 16.25 9.41421 16.25 9V7.75L15 7.75C14.5858 7.75 14.25 7.41421 14.25 7C14.25 6.58579 14.5858 6.25 15 6.25L16.25 6.25V5C16.25 4.58579 16.5858 4.25 17 4.25Z" fill="#1C274C"></path> </g></svg></a></div>
                </div>
                <div className="font-light">
                    <textarea
                        onChange={(e) => setNotas(e.target.value)}
                        class="form-control
                            block
                            w-full
                            px-3
                            py-1.5
                            text-base
                            font-normal
                            text-gray-700
                            bg-white bg-clip-padding
                            border border-solid border-gray-300
                            rounded
                            transition
                            ease-in-out
                            m-0
                            focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        placeholder="Notas"
                        rows={5}
                        cols={5}
                        value={notas}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                setUpdating(true);
                                e.target.blur();
                            }
                        }}
                    />
                </div>
                <div className="text-sm py-4">
                    Etiquetas<br></br>
                    <ReactSelectElement
                        options={etiquetas}
                        value={selectedTags}
                        isMulti
                        onChange={(e) => {
                            setSelectedTags(e);
                            setUpdating(true);
                        }
                        }
                    />
                </div>
                <div className="text-sm py-4">
                    Ejecutivo Asignado<br></br>
                    <ReactSelect
                        options={ejecutivos}
                        value={ejecutivoAsignado}
                        isMulti
                        onChange={(e) => {
                            setEjecutivoAsignado(e);
                            setUpdating(true);
                        }
                        }
                    />
                </div>
                <div className="text-sm py-4">
                    Enviar Plantilla<br></br>
                    <ReactSelect
                        options={templates}
                        value={plantillaSeleccionada}
                        onChange={(e) => {
                            setPlantillaSeleccionada(e);
                            setUpdating(true);
                        }
                        }
                    />
                    {
                        plantillaSeleccionada != [] > 0 &&
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white mt-5 font-bold py-2 px-4 rounded"
                            onClick={(e) => props.onSelectTemplate(e, { name: plantillaSeleccionada.label, id: plantillaSeleccionada.value, image: plantillaSeleccionada.image, video: plantillaSeleccionada.video })}
                        >Enviar</button>
                    }
                </div>
                {
                    cbp &&
                    expirationTimer.map((expTimer, idx) => {
                        return (
                            <div className="text-sm py-4">
                                {expirationType[idx]} Session Expires in<br></br>
                                <div key={idx} className="w-full bg-gray-200 rounded-full dark:bg-gray-700">
                                    <div id="timeleft" className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full" style={{ width: expirationWidth[idx] }}>{expTimer}</div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}